import graphql from "babel-plugin-relay/macro";

const PortfolioCurrentHoldingQuery = graphql`
query PortfolioCurrentHoldingQuery($userId:String){
   userCurrentHoldings(userId:$userId){
    edges{
      node{
        stock{
          id
          name
          politicianImage
          upcoming
          price
          party{
            partyName
          }
        
         
        }
        
        averagePrice
        currentHoldingsInvested
        diffPercentage
      
      }
    }
  }
}
`

export default PortfolioCurrentHoldingQuery
// stockOwnedCount
// priceDiff